module.exports = __webpack_public_path__ + "static/media/am-download.6357f35f.svg";